import { BakeShadows, Preload } from "@react-three/drei";

import { useCustomRayCaster } from "../../hooks/use-custom-ray-caster.js";
import { StartZone } from "../office-elements/start-zone.js";
import { useFpsLimit } from "../office-fps-limit/use-fps-limit.js";
import { DynamicDecorationRenderer } from "./dynamic-decoration-renderer.js";
import { DynamicFurnitureRenderer } from "./dynamic-furniture-renderer.js";
import { DynamicOfficeRoom } from "./dynamic-office-room.js";

export const OfficeScene = () => {
  useCustomRayCaster();
  useFpsLimit({ enabled: true, maxFps: 24 });

  return (
    <>
      <DynamicOfficeRoom />
      <StartZone />
      <DynamicFurnitureRenderer />
      <DynamicDecorationRenderer />

      <BakeShadows />
      <Preload all />
    </>
  );
};
